<template>
  <div class="change-meter-form">
    <el-dialog title="添加换表记录" :visible.sync="dialog.dialogFormVisible" width="40%" append-to-body>
      <el-form label-width="80px" :model="formData" :rules="rules" ref="formData" >
        <el-form-item label="选择表" prop="id">
          <el-select v-model="formData.id" placeholder="选择设备表" filterable >
            <el-option v-for="item in deviceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围" prop="time">
          <el-date-picker v-model="formData.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" :editable="false"
            start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00']" :clearable="false" unlink-panels
            :picker-options="pickerOptions" @change="timeVerification" class="form-date-picker"></el-date-picker>
        </el-form-item>
        <el-form-item label="操作人" prop="opUser">
          <el-input v-model="formData.opUser" placeholder="请输入操作人名称"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.description" type="textarea" autosize placeholder="备注信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave(formData)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'changeMeterForm',
  props: ['API', 'ChangeMeterData', 'temp', 'dialog'],
  data () {
    const checkName = (rules, value, callback) => {
      if (value[0] === ' ') {
        // callback(new Error('禁止空格,请重新输入'))
        callback(new Error('名称不可为空格'))
      } else {
        callback()
      }
    }
    return {
      deviceList: [],
      formData: {},
      rules: {
        id: [
          { required: true, message: '请选择设备表', trigger: 'change' }
        ],
        time: [
          { required: true, message: '请选择时间范围', trigger: 'change' }
        ],
        opUser: [
          { required: true, message: '请输入操作人名称', trigger: 'blur' },
          { validator: checkName, trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        start: '00:00',
        step: '00:30',
        end: '24:00'
      }
    }
  },
  created () {
    this.getDeviceData()
    this.formData = Object.assign({}, this.temp)
    this.time = ''
  },
  methods: {
    getDeviceData () {
      this.API.getter('info').then(val => {
        this.deviceList = val.data.map(item => {
          const newDevice = {}
          newDevice.id = item.id.id
          newDevice.name = item.name
          return newDevice
        })
      })
    },
    timeVerification () {
      const start = new Date(this.formData.time[0])
      const end = new Date(this.formData.time[1])
      if (end.getTime() - start.getTime() >= 30000 * 60) {
        //
      } else {
        this.$message.warning('结束与开始的日期时间，相差不足30分钟，请重新选择')
      }
    },
    handleSave (formData) {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          const tTime = this.formData.time
          this.formData.start = tTime[0]
          this.formData.end = tTime[1]
          const tStart = (new Date(tTime[0])).getTime()
          const tEnd = (new Date(tTime[1])).getTime()
          const compareTime = []
          // 过滤设备换表 取出开始结束时间
          for (const item of this.ChangeMeterData) {
            if (item.id === this.formData.id) {
              compareTime.push({
                start: new Date(item.start).getTime(),
                end: new Date(item.end).getTime()
              })
            }
          }
          if (compareTime.length > 0) {
            for (const item of compareTime) {
              if (item.end < tStart || item.start > tEnd) {
                //
              } else {
                this.$message.warning('换表时间不可重合，请重新选择')
                return false
              }
            }
            this.save(tEnd, tStart)
          } else {
            this.save(tEnd, tStart)
          }
        } else {
          this.$message.error('请核实填写信息后提交')
          return false
        }
      })
    },
    save (tEnd, tStart) {
      if (tEnd - tStart >= 30000 * 60) {
        delete this.formData.time
        delete this.formData.state
        for (const item in this.formData) {
          this.temp[item] = this.formData[item]
        }
        this.$emit('Save')
        this.dialog.dialogFormVisible = false
      } else {
        this.$message.warning('结束与开始的日期时间，相差不足30分钟，请重新选择')
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.change-meter-form {
  .form-date-picker {
    width: 92%;
  }
}
.form-dialog {
  min-width: 600px;
}
.el-range-editor.el-input__inner {
  width: 95%;
}

</style>
